// Pharmacies whose prescriber list is pulled from the pharmacy's own API
// rather than maintained by hand. All three run on Pharmetika.
//
// Keyed on the exact pharmacy_name the API returns, lowercased. This replaced
// a pair of substring checks (`includes('miller')`, `includes('nie')`) that
// were duplicated in two components and would quietly mis-route any future
// pharmacy whose name happened to contain those letters.
export const PROVIDER_SYNC_ENDPOINTS = {
  millers: "/api/providers/sync/",
  "nie's pharmacy": "/api/providers/sync-nies/",
  "a & o specialty pharmacy": "/api/providers/sync-ao/",
};

const key = (pharmacyName) => (pharmacyName || "").toLowerCase();

export const supportsProviderSync = (pharmacyName) =>
  Object.prototype.hasOwnProperty.call(PROVIDER_SYNC_ENDPOINTS, key(pharmacyName));

export const providerSyncEndpoint = (pharmacyName) =>
  PROVIDER_SYNC_ENDPOINTS[key(pharmacyName)] || "/api/providers/sync/";
